import React, {ReactElement, useState} from 'react';
import {Breed} from '../../../structures/models/breed';
import {useLocalUrl} from "../../../utils/formatters";
import {PUPPY_DEFAULT_IMAGE} from "../../../utils/constants";

interface BreedCardProps {
  breed: Breed;
  listingsType?: string;
}

const BreedCard: React.FC<BreedCardProps> = (data): ReactElement => {
  const {breed, listingsType} = data;
  const breedUrl = (breed.route_relative ?? useLocalUrl(breed.route)) + (listingsType === 'stud' ? `/stud` : '');
  const [thumbnailLoaded, setThumbnailLoaded] = useState<boolean>(false);

  const cloudThumbnail = () => {
    const thumbnailURL = breed.thumbnailUrl || '';

    if (thumbnailURL.includes('res.cloudinary.com') && !thumbnailURL.includes('c_fill')) {
      const mods = [
        'c_thumb,h_300,w_300',
      ];

      const extractedPublicId = thumbnailURL.split('upload/');
      return `${extractedPublicId[0]}upload/${mods.join('/')}/${extractedPublicId[1]}`;
    }

    return useLocalUrl(breed.thumbnailUrl);
  }

  const handleThumbnailImageLoaded = () => {
    setThumbnailLoaded(true);
  }

  return (
    <a className="breed-card"
       href={breedUrl}
    >
      <div className="card">
        <img src={cloudThumbnail()}
             alt={`Thumbnail photo of the breed ${breed.name}`}
             onLoad={handleThumbnailImageLoaded}
             onError={(e) => {
               e.currentTarget.src = PUPPY_DEFAULT_IMAGE;
             }}
        />
        <div className="card-body">
          <p className="card-text text-center">
            {breed.name}
          </p>
        </div>
      </div>
    </a>
  );
};

export default BreedCard;
